import React, { useCallback } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Anchor } from "hesus-ui-kit";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import { priceTypes } from "@utils/constants";
import { renderPriceWithCurrency } from "@utils/utils";
import { DivBackgroundOpacity } from "@utils/extra-style";
import "../../SolutionsList.scss";

const TextNode = (props) => {
  const { text, column, t } = props;
  const generalParams = useGetGeneralParameters();

  const getPriceType = useCallback((code) => {
    switch (parseInt(code, 10)) {
      case 0:
        return "";
      case 1:
        return t("Tt_&_Tp");
      case 2:
        return t("Tt+Tp");
      case 3:
        return t("Tp");
      case 4:
        return t("Tt");
      default:
    }
    return "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderBody = useCallback(() => {
    switch (column?.id) {
      case "treatmentPrice":
      case "transportPrice":
      case "tgap":
        return (
          <span>
            {(text.price || parseInt(text?.price, 10) === 0) &&
            generalParams?.countryCurrency
              ? renderPriceWithCurrency(
                  text.price,
                  text.unit,
                  generalParams?.countryCurrency[text.currency],
                  text.position
                )
              : ""}
          </span>
        );
      case "solutionTypeId":
        return (
          <span>
            {generalParams?.solutionType
              ? t(priceTypes[generalParams?.solutionType])
              : ""}
          </span>
        );
      case "priceType":
        return <span>{getPriceType(text)}</span>;
      case "allocation":
        return (
          <DivBackgroundOpacity opacity={text.isActive === 1 ? 1 : "0.2"}>
            <span
              style={{ color: "#0A4986", fontWeight: "700", fontSize: "14px" }}
            >
              {text?.allocation ? `${text.allocation}%` : "-"}
            </span>
          </DivBackgroundOpacity>
        );
      case "platform":
        return (
          <>
            {text === "0" && <span>{t("NO")}</span>}
            {text === "1" && <span>{t("YES")}</span>}
          </>
        );
      case "supplierName":
      case "centreName":
        return (
          <DivBackgroundOpacity opacity={text.isActive === 1 ? 1 : "0.2"}>
            <div
              style={{
                color: "#0A4986",
                fontWeight: "700",
                fontSize: "14px",
                maxWidth: "300px",
                wordWrap: "break-word",
              }}
            >
              <Anchor
                target="_blank"
                rel="noreferrer"
                url={`/company/view/${text.id}/general-info`}
                className="solutions-list__solution-link"
              >
                {text.priceType === 3 && text.name}
                {text.priceType !== 3 &&
                  "[" + text.supplierName + "] " + text.name}
              </Anchor>
            </div>
          </DivBackgroundOpacity>
        );

      case "siteCompany":
        return (
          <DivBackgroundOpacity opacity={text.isActive === 1 ? 1 : "0.2"}>
            <div
              style={{
                color: "#0A4986",
                fontWeight: "700",
                fontSize: "14px",
                maxWidth: "300px",
                wordWrap: "break-word",
              }}
            >
              <Anchor
                target="_blank"
                rel="noreferrer"
                url={`/site/view/${text.siteId}/general-info`}
                className="solutions-list__solution-link"
              >
                {"#" + text.siteId + "-" + text.siteName}
              </Anchor>
              <br />
              <i>{text.companyName}</i>
            </div>
          </DivBackgroundOpacity>
        );

      case "productName":
        return (
          <DivBackgroundOpacity opacity={text.isActive === 1 ? 1 : "0.2"}>
            <span>{text.productName}</span>
          </DivBackgroundOpacity>
        );

      default:
        return <span>{text}</span>;
    }
  }, [
    column?.id,
    text,
    generalParams?.countryCurrency,
    generalParams?.solutionType,
    t,
    getPriceType,
  ]);

  return <>{renderBody()}</>;
};

TextNode.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({}),
  ]),
  column: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])
    .isRequired,
  t: PropTypes.func.isRequired,
};

TextNode.defaultProps = {
  text: "",
};

export default withTranslation()(TextNode);
